import type { ReactElement } from 'react';
import { ErrorCode } from '@gr/core/errors';
import { useT } from '../../../../app/di';
import { FormAlert, FormTextField, useServerForm } from '../../../../ui-kit/form/form';
import type { ServerOutcome } from '../../../../ui-kit/form/server-errors';

/** IAM-UC-7: новый пароль пользователю; отправляется кнопкой с form={id}. */
export function ResetPasswordForm({ id, onSubmit }: { id: string; onSubmit(password: string): Promise<ServerOutcome> }): ReactElement {
  const { t } = useT();
  const { form, submit } = useServerForm<{ password: string }>({ defaultValues: { password: '' }, fields: ['password'], onSubmit: ({ password }) => onSubmit(password) });
  return (
    <form id={id} className="u-stack" onSubmit={submit} noValidate>
      <FormAlert form={form} />
      <FormTextField
        control={form.control}
        name="password"
        label={t('identity.profile.newPassword')}
        type="password"
        autoComplete="new-password"
        rules={{ required: ErrorCode.FieldRequired }}
        disabled={form.formState.isSubmitting}
      />
    </form>
  );
}
